const labels = {
  All: { 'See the offering': 'Смотрите предложение' },
  FacilityDetails: { 'Ref: Page title': 'Подробнее Facility', 'Ref: Review': 'Обзор' },
  FacilitiesList: { 'Ref: Page title': 'оборудование', 'Ref: See details': 'Смотрите подробности' },
};
export default labels;
